import { Typography, IconButton, Box } from '@mui/material';
import React from 'react'
import { dataConstants } from '../../../../constants';
import { getTabData } from '../../../../helpers';
import ChartItem from '../../../_common/Skeleton/chart';
import dynamic from 'next/dynamic';
const D3Chart = dynamic(() => import('../../../_common/D3Chart'),
  { loading: () => <ChartItem /> })
import ShareThis from '../../../_common/ShareThis';
import CollapseCard from '../../CollapseCard';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';

const { ECO_SECTION_CODES } = dataConstants || {};

const NonDurables = ({ data, consData, getChartData, onChangeInfo, handleClick, themes, selectedInfo }) => {

  const consumerNonDura = data && data.find(d => d.section_code === ECO_SECTION_CODES.CONS_C_NON_DUR) ? data.find(d => d.section_code === ECO_SECTION_CODES.CONS_C_NON_DUR) : undefined;
  const consumerNonDuraChart = consumerNonDura && consumerNonDura.tabData ? getChartData(consumerNonDura.tabData, getTabData(consData, consumerNonDura, ECO_SECTION_CODES.CONSUMER_DATA)) : undefined;

  return (
    <>
      {consumerNonDura &&
        <Box component="div" className="col-md-4" sx={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
          <Box component="div">
            <Box
              className="section"
              sx={{
                display: 'flex',
                alignItems: 'center',
                mb: 1.4,
                px: 0.5,
              }}
            >
              <Typography component="h4" className="option-title" sx={{ mr: 'auto' }} >
                {consumerNonDura.section_name}
              </Typography>
              {/* <IconButton aria-label="info" onClick={() => onChangeInfo(consumerNonDura.section_code)}>
                <InfoRoundedIcon size="small" sx={{ fontSize: '1.2rem', color: 'text.link' }} />
              </IconButton> */}
              <ShareThis
                link={encodeURI(`${process.env.NEXT_PUBLIC_URL}${dataConstants.NAVS.CHART_SHARE}/${consumerNonDuraChart?.code}/${consumerNonDuraChart?.series.map(d => d.yformula).join(';')}/${consumerNonDura.section_name}`)}
                title={`${consumerNonDura.section_name}`}
                message={`${consumerNonDura.section_name}`}
                subject={''}
              />
            </Box>
            {consumerNonDuraChart && consumerNonDuraChart.description && <Box component="div" className="option-desc" sx={{ mb: 2, px: 2 }}><Typography variant="caption" sx={{ color: 'text.description' }} dangerouslySetInnerHTML={{ __html: consumerNonDuraChart.description }} /></Box>}
          </Box>
          <Box component="div">
            <Box component="div" className="option-content eco-chart" sx={{ position: 'relative', pr: 2, minHeight: '12rem' }}>
              <D3Chart
                showChart={true}
                noHeader
                // maxHeight={chartProps.maxHeight}
                scale={1}
                // onClick={code => handleClick(code)}
                chart={{ ...consumerNonDuraChart, id: consumerNonDura.section_code, tick: 2 }}
                // userName={`@${chart.code.split('@')[1]}`}
                themes={themes}
                type={dataConstants.CHART_STATE.VIEW}
                // axisTextMargin={chartProps.axisTextMargin}
                chartMargin={{ left: 40, bottom: 48 }}
                axisTextMargin={{ y: 96 }}
                // wrapperClass="StockCardImage"
                //showLegend={false}
                showCrosshair
              />
            </Box>
            <CollapseCard
              selectedInfo={selectedInfo}
              section_code={consumerNonDura?.section_code}
              chart_codes={consumerNonDuraChart}
              handleClick={handleClick}
            />
          </Box>
        </Box>}
    </>
  )
}

export default NonDurables
